let i = 1
/**
 * La liste des filtres possibles
 * @type {Object<string, FilterDef>}
 */
const filters = {
  // lui sera éliminé par isFilterEnabled pour un bilan élève
  participants: {
    label: 'Participants',
    id: 'participants',
    stores: [
      { id: 0, name: 'Tous' },
      { id: 1, name: 'ayant participé' },
      { id: 2, name: "n'ayant pas participé" },
      { id: 3, name: 'ayant atteint la dernière ressource' },
      { id: 4, name: "n'ayant pas atteint la dernière ressource" },
      { id: 5, name: "ayant participé mais n'ayant pas atteint la dernière ressource" }
    ]
  },
  dates: {
    id: 'dates',
    label: 'Dates',
    stores: [
      { id: 0, name: "N'importe quand" },
      { id: 1, name: "Aujourd'hui" },
      { id: 2, name: 'Hier' },
      { id: 3, name: 'Moins de 3 jours' },
      { id: 4, name: 'Plus de 3 jours' }
    ]
  },
  // typeScore seulement pour la vue table
  typeScore: {
    id: 'typeScore',
    label: 'Affichage du score',
    stores: [
      { id: i++, name: 'Score en % avec le nombre d’essais', withEssais: true, withPc: true },
      { id: i++, name: 'Score en % sans le nombre d’essais', withPc: true },
      { id: i++, name: 'Score numérique (sans le nombre d’essais, séparateur virgule)', isNum: true, withComma: true },
      { id: i++, name: 'Score numérique (sans le nombre d’essais, séparateur point)', isNum: true },
      { id: i++, name: 'Note sur 20 avec le nombre d’essais', withEssais: true, isNote20: true },
      { id: i++, name: 'Note sur 20 sans le nombre d’essais', isNote20: true },
      { id: i++, name: 'Note sur 20 numérique (sans /20 ni le nombre d’essais)', isNum: true, isNote20: true },
      { id: i++, name: 'Note sur 20 numérique (au dixième, séparateur virgule)', isNum: true, isNote20: true, isDecimal: true, withComma: true },
      { id: i++, name: 'Note sur 20 numérique (au dixième, séparateur point)', isNum: true, isNote20: true, isDecimal: true },
      { id: i++, name: 'Note sur 10 avec le nombre d’essais', withEssais: true, isNote10: true },
      { id: i++, name: 'Note sur 10 sans le nombre d’essais', isNote10: true },
      { id: i++, name: 'Note sur 10 numérique (sans /10 ni le nombre d’essais)', isNum: true, isNote10: true },
      { id: i++, name: 'Note sur 10 numérique (au dixième, séparateur virgule)', isNum: true, isNote10: true, isDecimal: true, withComma: true },
      { id: i++, name: 'Note sur 10 numérique (au dixième, séparateur point)', isNum: true, isNote10: true, isDecimal: true }
    ]
  }
}

// id et value seront affectées dans initFilters
/**
 * les ckeckboxes possibles
 * @type {Object<string, CheckboxDef>}
 */
const checkboxes = {
  elevesDeLaSequenceOnly: {
    label: 'Afficher seulement les élèves encore présent dans la séquence',
    id: '',
    value: false
  },
  elevesFilteredByDate: {
    label: 'Ne pas afficher les élèves sans résultat vérifiant le filtre "Dates" ci-dessus',
    id: '',
    value: false
  },
  sansMoyenne: {
    label: 'Ne pas afficher la colonne moyenne',
    id: '',
    value: false
  },
  moyenneWithFinishedOnly: {
    label: 'Ne compter que les résultats des exercices terminés dans la moyenne',
    id: '',
    value: false
  }
}

/**
 * Retourne la clé du filtre pour localStorage
 * @param {{id: string}} filter
 * @returns {string}
 */
const getCurrentFilterKey = (filter) => `filter-${filter.id}-currentId`

/**
 * Init des valeurs des select / checkboxes d'après localStorage
 * @param $scope
 * @param {Object} [onChanges] des éventuelles callback pour être rappelé au changement d'une valeur
 */
function initFilters ($scope, onChanges = {}) {
  // init de current pour chaque filter (select)
  for (/* @type {FilterDef} */ const filter of Object.values(filters)) {
    let current
    try {
      const memo = localStorage.getItem(getCurrentFilterKey(filter))
      if (memo) {
        const id = Number.parseInt(memo, 10)
        current = filter.stores.find((store) => store.id === id)
      }
    } catch (error) {
      console.error(error)
    }
    filter.current = current ?? filter.stores[0]
  }
  // les checkboxes
  for (const [id, cb] of Object.entries(checkboxes)) {
    cb.id = id
    cb.value = localStorage.getItem(getCurrentFilterKey(cb)) === 'on'
    if (onChanges[id]) {
      // faut un getter/setter pour être rappelé quand ça change
      let value = cb.value
      delete cb.value
      Object.defineProperty(cb, 'value', {
        enumerable: true,
        configurable: true,
        get: () => value,
        set: (newValue) => {
          value = Boolean(newValue)
          $scope[cb.id] = value
          onChanges[cb.id](value)
        }
      })
    }
  }
  // et on met tout ça dans le scope
  $scope.filters = filters
  /**
   * La liste des checkboxes possibles
   * @type {Object<string, CheckboxDef>}
   */
  $scope.checkboxes = checkboxes
  $scope.eleveFilter = eleveFilter.bind(null, $scope)
  $scope.rowFilter = dateFilter.bind(null, $scope)
}

// au changement de la valeur d'un filtre on mémorise dans localStorage
function saveFilter (filter) {
  // console.log('saveFilter', filter)
  try {
    const key = getCurrentFilterKey(filter)
    if (filter.stores) {
      if (!filter.stores[filter.current.id]) {
        return console.error(Error('filter invalide'), filter)
      }
      localStorage.setItem(key, filter.current.id)
    } else {
      // checkbox
      localStorage.setItem(key, filter.value ? 'on' : 'off')
    }
  } catch (error) {
    console.error(error)
  }
}

/**
 * Retourne le nb de jours entiers entre date et maintenant (0 => aujourd'hui, 1 hier, etc.)
 * @param {string} date La date issue du JSON de l'api (format YYYY-MM-DDTHH:mm:ss.sssZ)
 * @returns {number}
 */
function days (date) {
  const t0 = (new Date()).setHours(0, 0, 0, 0)
  const t1 = (new Date(date)).setHours(0, 0, 0, 0)
  // round au cas où y'aurait un pb arrondi dans le calcul interne js
  return Math.round((t0 - t1) / 86_400_000)
}

/**
 * Retourne true si l'élève de cette ligne match les filtres
 * @param $scope
 * @param {BilansEleve|ScoresTableRow} data
 * @returns {boolean}
 */
function eleveFilter ($scope, data) {
  if ($scope.checkboxes.elevesDeLaSequenceOnly.value && !data.dansLaSequence) return false
  let results, hasResult
  if (Array.isArray(data.rows)) {
    /** @type BilansEleveRow[] */
    results = data.rows
    hasResult = results.length > 0
  } else {
    /** @type ScoresTableRow */
    results = data
    hasResult = data.hasResult
  }
  // un 1er étage de filtre d'après participants
  let firstFiltering = false
  switch ($scope.filters.participants.current.id) {
    // tous
    case 0: firstFiltering = true; break
    // ayant participé
    case 1: firstFiltering = hasResult; break
      // n'ayant pas participé
    case 2: firstFiltering = !hasResult; break
    case 3: firstFiltering = data.reachLast; break
    case 4: firstFiltering = !data.reachLast; break
    case 5: firstFiltering = !data.reachLast && hasResult; break
    default:
      console.error(Error('filter invalide'), $scope.filters.participants.current)
  }
  if ($scope.checkboxes.elevesFilteredByDate.value) {
    // le 2e étage de filtrage si aucun bilan ne match le filtre date
    return firstFiltering && results.some(row => dateFilter($scope, row))
  }
  return firstFiltering
}

// helper pour la vue liste
/**
 * Retourne true si ce résultat match le filtre date
 * @param $scope
 * @param {BilansEleveRow|ScoresTableCell} data
 * @returns {boolean}
 */
function dateFilter ($scope, data) {
  // data est un resultat, une ligne pour la vue liste et une cellule pour la vue table
  if (data.$date == null) return false
  if ($scope.filters.dates.current.id === 0) return true
  const nbDays = days(data.$date)
  switch ($scope.filters.dates.current.id) {
    case 1: return nbDays === 0
    case 2: return nbDays === 1
    case 3: return nbDays <= 3
    case 4: return nbDays > 3
  }
  console.error(Error('filter dates invalide'), $scope.filters.dates.current)
  return false
}

module.exports = {
  days,
  dateFilter,
  eleveFilter,
  saveFilter,
  initFilters
}

/**
 * @typedef {Object} FilterDef
 * @property {string} label
 * @property {string} id
 * @property {Filter[]} stores
 */
/**
 * @typedef {Object} Filter
 * @property {number} id
 * @property {string} name
 * @property {boolean} [isDecimal]
 * @property {boolean} [isNote20]
 * @property {boolean} [isNote10]
 * @property {boolean} [isNum]
 * @property {boolean} [withComma]
 * @property {boolean} [withEssais]
 * @property {boolean} [withPc]
 */
/**
 * @typedef {Object} CheckboxDef
 * @property {string} id
 * @property {string} label
 * @property {boolean} value
 */
